import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import useMediaQuery from '@mui/material/useMediaQuery';

function Box({ children }) {
    return (
        <div
            style={{
                display: 'block',
                lineHeight: 1,
                marginBottom: '8px',
                width:'100%',
                height:'16px'
            }}
        >
            {children}
        </div>
    );
}

const AdditionalInfoSkeleton = (props) => {
    
    const breakpoint = useMediaQuery('(max-width: 920px)');
    const containerStyle = {
        padding:props.inModal?'0': '16px 32px 0 32px',
        display: 'flex',
        flexDirection:breakpoint?'column':'row',
        gap: '16px',
        width:'100%',
        marginBottom: '32px'
    };
    const columnStyle = {
        width: breakpoint ? '100%' : '50%'
    };
    const subContainerStyle = {
        marginBottom: '16px',
        padding: '16px 0',
    }
    const flexContainerStyle = {
        display: 'flex',
        flexDirection:breakpoint?'column':'row',
        width:'100%',
        justifyContent: 'space-between',
        gap: '16px'
    };
    const flexColumn = {
     width:breakpoint?'100%':'50%'
    };
    const flexSubWidth = {
        width: breakpoint ? '100%' : '176px'
    };
    return (
        <SkeletonTheme baseColor="#D8DBE0" highlightColor="#EDF1F6" borderRadius={'4px'}>
            <div style={containerStyle}>
           
            <div style={columnStyle}>
                    <div style={subContainerStyle}>
                        <Skeleton wrapper={Box} width={116} height={16} /> 
                        <Skeleton wrapper={Box} height={16} /> 
                    </div>
                    <div style={subContainerStyle}>
                        <Skeleton wrapper={Box} width={116} height={16} />
                        <Skeleton wrapper={Box} count={2} height={16} />
                    </div>

                    <div style={subContainerStyle}>
                        <div style={flexContainerStyle}>
                            <div style={flexColumn}>
                                <Skeleton wrapper={Box} width={116} height={16} />
                                <div style={flexSubWidth}>
                                    <Skeleton wrapper={Box} height={16} />
                                </div>
                            </div>
                            <div style={flexColumn}>
                                <Skeleton wrapper={Box} width={116} height={16} />
                                <div style={flexSubWidth}>
                                <Skeleton wrapper={Box} height={16} />
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={columnStyle}>
                    <div style={subContainerStyle}>
                        <Skeleton wrapper={Box} width={116} height={16} />
                        <Skeleton wrapper={Box} count={2} height={16} />
                    </div>
                    <div style={subContainerStyle} style={{marginBottom:'138px'}}>
                        <Skeleton wrapper={Box} width={116} height={16} />
                        <Skeleton wrapper={Box} height={155} />
                    </div>
                </div>           
            </div>
        </SkeletonTheme>
    );
}

export default AdditionalInfoSkeleton;
